// Driving distance in miles between two points, asked of the free OSRM service
// FROM THE BROWSER. Used when the web server can't make the secure connection itself
// (older shared hosting). Put this file next to GigsTable.js and CalendarUpdate.js
// (src/components/admin/).
export async function routeMiles(from, to) {
    const url =
        `https://router.project-osrm.org/route/v1/driving/` +
        `${from.lon},${from.lat};${to.lon},${to.lat}?overview=false`;

    const res = await fetch(url);
    if (!res.ok) throw new Error(`Route service answered ${res.status}`);

    const data = await res.json();
    if (data.code !== "Ok" || !data.routes?.length) {
        throw new Error("No driving route was found.");
    }

    return Math.round((data.routes[0].distance / 1609.344) * 10) / 10;
}